import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Table, Input, Button, ButtonGroup, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import ColumnFilters from './components/ColumnFilters';
import Loader from 'components/Loader';
import crossIcon from 'assets/icon/cross.png';
import searchIcon from 'assets/icon/search.png';
import leftArrowIcon from 'assets/icon/cps-left-arrow.svg';
import rightArrowIcon from 'assets/icon/cps-right-arrow.svg';
import Pagination from 'components/Pagination';
import { find, result } from 'lodash';
import { ModuleAccess } from 'utils/moduleaccess';
import download from "assets/icon/download-icon.svg";
import collapse from "assets/icon/collapse-icon.svg";
import collapseclose from "assets/icon/collapse-icon-close.svg";
import SortDown from "../../assets/icon/Sort_Down.svg";
import upload from "../../assets/icon/upload-icon.svg";
import plus from "assets/icon/plus-icon.svg";
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import save from "assets/icon/save.svg";
import cancel from "assets/icon/cancel.svg";
import { useLocation } from 'react-router-dom';

let keysName = [];
let columnChangedFilters = [];
let isHaveColFilter = false;

const ReactStrapTable = ({
  id,
  columns,
  data,
  fixedColumn,
  hidefilter,
  handleSort = () => '',
  loading,
  reset,
  loader,
  hasScrollArrow = true,
  onFilterCancel = () => '',
  onSearchColumnFilters = () => '',
  pageSize,
  onPageSizeChange = () => '',
  children,
  onExport,
  AllExport,
  slelectedExport,
  onSelectColoums,
  hasPagination,
  onPageChange,
  currentPage,
  totalRecords,
  filters,
  researchNeededCount = 0,
  eligibleCount = 0,
  inEligibleCount = 0,
  hasNoEligibility = true,
  hasExportPermission = true,
  Nodataflag,
  gridMsg = Nodataflag == true ? <span className="text-danger f-12"> 'No records found'  </span>: 'No records found',
  hasColselect = false,
  autoselectlist1,
  add,
  addbutton,
  buttononclick,
  saveEdit,
  cancelonClick,
  saveonClick,
  accuntErr,
  enabletogglesider = true,
  toggleSider,
  collapseSider,
  showtoggle,
  showreportscount,
  display,
  addAccmulations,
resetFilterFlag,
SetResetFilterFlag,
name,
keytab,resetKey,isNonSplit
}) => {
  const [key, setKey] = useState('');
  const [resetField, setResetField] = useState(false);
  const [hasVisibleScrollArrow, setVisibleScrollArrow] = useState(false);
  const [hasLeftArrow, setLeftArrow] = useState(false);
  const [hasRightArrow, setRightArrow] = useState(false);
  const [rSelected, setRSelected] = useState('off');
  const [colFilterEnable, setColFilterEnable] = useState(false);
  const [sortKey, setSortKey] = useState('desc');
  const selectRef = useRef(null);
  // useEffect(() => {
  //   columnChangedFilters = [];
  // }, []);
  const getUpdateColum = () => {
    const updateCol = [];
    const col = columns[0];
    if (!col?.action && colFilterEnable) {
      updateCol.push({
        dataField: 'Options',
        text: 'Options',
        width: 80,
        show: false,
        disabled: true,
        hideColFilter: true,
        action: true,
      });
    }
    return [...updateCol, ...columns];
  };
  //debugger
   useEffect(() => {
    if(resetFilterFlag && resetFilterFlag !==undefined){
      SetResetFilterFlag(false);
      onClickFilter('off')
    }
  }, [resetFilterFlag]);
  const location = useLocation();
  
  useEffect(() => {
    // console.log(id,"id")
    console.log(keytab,"keytab")
    setKey('');
    keysName=[]
    setSortKey("desc")
  }, [reset,location,keytab,id,]);
  // useEffect(() => {
  //   setKey('');
  //   keysName=[]
  // }, [id]);
  const removeSort = (keys) => {
    debugger
    keysName.push(keys);
    const filter = keysName.filter((item) => item === keys);
    let sortOrder = filter?.length === 1 ? 'asc' : filter?.length === 2 ? 'desc' : 'asc'
     if(filter?.length === 1 && keysName?.length > 1){
      keysName=[];
      keysName.push(keys);
     }

    if (filter.length === 3) {
      setKey('');
      //setSortKey('desc');
      keysName = [];
    } else {
      const sortObj = {
        order: sortOrder,   // sortKey === 'desc' ? 'asc' : 'desc',
        orderBy: keys,
      };
      setSortKey(sortObj.order);
      if (isHaveColFilter) {
        const apiFilter = {
          ...filters,
          ...sortObj,
          filters: [...columnChangedFilters],
        };
        // handleSort(filters, keys === "claimStatus" ? "claimID" : keys, true, columnChangedFilters);
        handleSort(apiFilter, true);
      } else {
        const apiFilter = { ...filters, ...sortObj };
        // handleSort(filters, keys === "claimStatus" ? "claimID" : keys);
        handleSort(apiFilter,false);
      }
    }
  };

  const onColHeaderClick = (col) => {
    if (col.disabled) return;
    setKey(col.dataField);
    removeSort(col.dataField);
  };
  const getRowClass = (claimEligibilityID,id) => {
   
    // switch (claimEligibilityID,id) {
    //   case 1203:
    //     return "table-striped1"; // CSS for ID 1203
    //   case 1202:
    //     return "table-striped2"; // CSS for ID 1202
    //   case 1204:
    //     return "table-striped3"; // CSS for ID 1204
    //     case "reportsummery-table":
    //       return "table-striped4"; // CSS for ID 1204
    //   default:
    //     return "table-striped"; // Default styling
    // }
    if(claimEligibilityID=="1203"){
          return "table-striped1"; // CSS for ID 1203

    }
   else if(claimEligibilityID=="1202"){
      return "table-striped2"; // CSS for ID 1203

}
else if(claimEligibilityID=="1204"){
  return "table-striped3"; // CSS for ID 1203

}
if(id=="reportsummery-table"){
  return "table-striped4"; // CSS for ID 1203

}
else{
  return "table-striped"
}
  };
 
  const getTableClass = (data,id) => {
    if(id=="reportsummery-table"){
      return  "table-striped-report";

    }
    else{
    const hasSpecialClaimID = data.some((row) =>
      [1203, 1202, 1204].includes(row?.auditItemStatusID)
    );

    return hasSpecialClaimID ? "table-striped-audit" : "table-striped";
  }
  };
 
  const headerRenderer = () => {
    const cols = getUpdateColum().map((col, index) => {
      // console.log(col,"col")
      return (
        <th
          key={col.dataField}
          className={
            key === col.dataField
              ? `active-sorting-${sortKey === 'asc' ? 'down' : 'up'}`
              : ''
          }
          width={col.width || 100}
          onClick={() => {
            col.sort ? onColHeaderClick(col) : '';
          }}
          hidden={!col.show}
        >
          <div className="d-flex justify-content-between align-items-center">
          <div 
          //  style={{ width: keysName.length>=1?col.width - 17 :""}}
          className=''>
  {col.text}
          </div>
          
            {col.sort == true && sortKey == "desc" && keysName.length == 0 ? (
              <span
                className=""
                style={{
                  marginLeft: "8px",
                  position: "relative",
                  verticalAlign: "sub",
                  marginTop: "7px",
                }}
              >
                <img
                  src={SortDown}
                  alt=""
                  //  onClick={() => {
                  //    col.sort ? onColHeaderClickTop(col) : '';
                  // }}
                />
                <img
                  className="filters_col"
                  src={SortDown}
                  alt=""
                  // onClick={() => {
                  //   col.sort ? onColHeaderClickDown(col) : '';
                  // }}
                />
              </span>
            ) : (
              ""
            )}
          </div>
          {/* {col.text} */}
        </th>
      );
    });
    return (
      <thead key='headerrow'>
        <tr>
          {/* {colFilterEnable && columns[0].action ? <th width={100}>Options</th> : ""} */}
          {cols}
          {/* {colFilterEnable && <th width={100}>Options</th>} */}
        </tr>
      </thead>
    );
  };
  // const renderRow = () => {
  //   if (data?.length) {
  //     const rows = data.map((row, index) => {
  //       const rowItem = getUpdateColum().map((col) => {
  //         // if (index === 0 && colFilterEnable) {
  //         //   return <th key="option" width={100}></th>;
  //         // }
  //         if (col.cellRenderer) {
  //           return (
  //             <td
  //               key={col.dataField}
  //               width={col.width || 100}
  //               className={col.edit ? 'py-1' : col.className || ''}
  //               hidden={!col.show}
  //             >
  //               {col.cellRenderer(row, col)}
  //             </td>
  //           );
  //         }
  //         return (
  //           <td key={col.dataField} width={col.width || 100} hidden={!col.show}>
  //             {row[col.dataField]}
  //           </td>
  //         );
  //       });
  //       return (
  //         <tr key={index}>
  //           {rowItem}
  //           {/* {colFilterEnable && <td width={100}></td>} */}
  //         </tr>
  //       );
  //     });
  //     return rows;
  //   } else {
  //     return (
  //       <tr>
  //         <td colSpan={getUpdateColum().length} className='text-center'>
  //           {loading ? 'Loading...' : gridMsg}
  //         </td>
  //       </tr>
  //     );
  //   }
  // };
  const renderRow = () => {
    if (data.length) {
      const rows = data.map((row, index) => {
        const rowClass = getRowClass(row?.auditItemStatusID,id); // Get the row class based on claimEligibilityID
        // console.log(rowClass,"rowclass")

        const rowItem = getUpdateColum().map((col) => {
          if (col.cellRenderer) {
            return (
              <td
                portalId="root portal"
                key={col.dataField}
                width={col.width || 100}
                className={col.edit ? "py-1" : col.className || ""}
                hidden={!col.show}
              >
                {col.cellRenderer(row, col)}
              </td>
            );
          }

          return (
            <td key={col.dataField} width={col.width || 100} hidden={!col.show}>
              {row[col.dataField]}
            </td>
          );
        });
        if(id=="reportsummery-table"){
          return (
          
            <tr key={index} className={(id=="reportsummery-table" && (data.length-1 == index)?rowClass:"")}>
              {" "}
              {rowItem}
            </tr>
          );
        }
        else{
          return (
          
            <tr key={index} className={rowClass}>
              {" "}
              {rowItem}
            </tr>
          );
        }

       
      });

      return rows;
    } else {
      return (
        <tr>
          <td colSpan={getUpdateColum().length} className="text-center">
            {loading ? "Loading..." : gridMsg}
          </td>
        </tr>
      );
    }
  };

  const handleColumnFilterChange = ({ target: { value } }, col, type, filterType) => {
    debugger;  
     value = value.trim();
     value = value === 'Invalid date' ? "" : value;

     filterType = filterType != "" ? parseInt(filterType) : filterType == "" ? 1 : 1
    const { dataField } = col;
    const obj = {
      filterName: dataField,
      filterType: filterType === "" ? 1 : filterType,
    };
    if (!value) {
      const filter = columnChangedFilters?.filter(
        (item) => item.filterName !== dataField
      );
      columnChangedFilters = filter;
      return;
    }
    const findObj = find(columnChangedFilters, {
      filterName: dataField,
    });
    if (findObj) {
      if (type === 'field') {
        findObj.filterValue = value;
      } else {
        findObj.filterType = parseInt(value);
      }
    } else {
      if (type === 'field') {
        obj.filterValue = value;
      } else {
        obj.filterType = parseInt(value);
      }
      const colFilters = [...columnChangedFilters, ...[obj]].filter(
        (item) => item.filterValue
      );
      columnChangedFilters = colFilters;
    }
  };

  const onSearchFilter = () => {
    isHaveColFilter = true;
    onSearchColumnFilters(columnChangedFilters);
  };

  const onCancelFilter = () => {
    isHaveColFilter = false;
    onFilterCancel();
    setResetField((pre) => !pre);
    columnChangedFilters = [];
  };
  const hasPermission1 = (code) => {
    return ModuleAccess("CON", code);
}
  const hasPermission = (code) => {   
    return ModuleAccess("ACC", code);
}

const hasPermission2 = (code) => {
  return ModuleAccess("PCO", code);
}

const hasPermission3 = (code) => {
  return ModuleAccess("ADT", code);
}

const hasPermission4 = (code) => {
  return ModuleAccess("ACC", code);
}
  const columnFilters = () => {
    var ids = [];
    if (hasColselect) {
      if (autoselectlist1.length > 0)
        for (var x in autoselectlist1) {
          ids.push(autoselectlist1[x].text)
        }
    }

    return (
      <tr className='filter_tdfixed'
      //  style={{ position: "sticky", top: "48px", "zIndex": 11 }}
       >
        {getUpdateColum()?.map((col, index) => {
          if (index === 0) {
            return (
              <td key='action'>
                <span className='pe-2 cursor-pointer' onClick={onSearchFilter}>
                  <img src={searchIcon} alt='' />
                </span>
                <span className='cursor-pointer' onClick={onCancelFilter}>
                  <img src={crossIcon} alt='' />
                </span>
              </td>
            );
          }
          if (col.hideColFilter) {
            return <td key={col.dataField}></td>;
          }
          return (
            <td key={col.dataField}   >
              <ColumnFilters
                col={col}
                onColumnFilterChange={handleColumnFilterChange}
                reset={resetField}
              />
            </td>
          );
        })}
      </tr>
    );
  };

  const getCurrentTableElement = () =>
    document
      .querySelector(`#${id}`)
      .getElementsByClassName('table-responsive')[0];

  const handleMouseEnter = () => {
    if (!id) return;
    const element = getCurrentTableElement();
    const rightScroll =
      element.scrollWidth - element.scrollLeft - element.clientWidth;
    if (rightScroll <= 10 && element.scrollLeft <= 10) return;
    if (element.scrollLeft <= 0) {
      setLeftArrow(false);
      setRightArrow(true);
    } else {
      setLeftArrow(true);
    }
    if (rightScroll <= 0) {
      setLeftArrow(true);
      setRightArrow(false);
    }
    setVisibleScrollArrow(true);
  };

  const handleMouseLeave = () => {
    setVisibleScrollArrow(false);
  };

  const scroll = (direction) => {
    const element = getCurrentTableElement();
    slideScroll(element, direction, 50, 500, 70);
  };

  const slideScroll = (element, direction, speed, distance, step) => {
    let scrollAmount = 0;
    var slideTimer = setInterval(function () {
      element.behavior = 'smooth';
      if (direction == 'left') {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);

    setTimeout(() => {
      const el = getCurrentTableElement();
      const rightScroll = el.scrollWidth - el.scrollLeft - el.clientWidth;
      if (el.scrollLeft === 0) {
        setLeftArrow(false);
      } else {
        setLeftArrow(true);
      }
      if (rightScroll <= 0) {
        setRightArrow(false);
      } else {
        setRightArrow(true);
      }
    }, 500);
  };

  const renderScrollArrowButtons = () => {
    if (hasScrollArrow && hasVisibleScrollArrow && data && data.length) {
      return (
        <>
          {hasLeftArrow && (
            <Button
              onClick={() => scroll('left')}
              color='link'
              className={`left-table-button ${!hasLeftArrow ? 'opacity-25' : ''
                }`}
              disabled={!hasLeftArrow}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <img
                src={leftArrowIcon}
                alt='leftArrowIcon'
                height={32}
                width={32}
              />
            </Button>
          )}
          {hasRightArrow && (
            <Button
              onClick={() => scroll('right')}
              color='link'
              className={`right-table-button ${!hasRightArrow ? 'opacity-25' : ''
                }`}
              disabled={!hasRightArrow}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <img
                src={rightArrowIcon}
                alt='rightArrowIcon'
                height={32}
                width={32}
              />
            </Button>
          )}
        </>
      );
    }
    return null;
  };

  const onClickFilter = (value) => {
    if (value === 'on') {
      setRSelected(value);
      setColFilterEnable(true);
    } else {
      setRSelected(value);
      setColFilterEnable(false);
      if(!resetFilterFlag){
      onCancelFilter();
      }
        
    }
    columnChangedFilters = [];
  };

  const onHandlePageChange = (page) => {
    debugger
    const pageFilter = { ...filters, currentPage: page };
    if (isHaveColFilter) {
      let colFilterOn = { ...pageFilter, filters: columnFilters };
      return onPageChange(colFilterOn, true, columnChangedFilters);
    }
      onPageChange(pageFilter);
  };

  const handlePageSizeChange = (e) => {
    const { value } = e.target;
    const pageFilter = {
      ...filters,
      currentPage: 1,
      pageSize: parseInt(value),
    };
    if (isHaveColFilter) {
      let colFilterOn = { ...pageFilter, filters: columnFilters };
      return onPageSizeChange(colFilterOn, true, columnChangedFilters);
    }
    onPageSizeChange(pageFilter);
  };

  return (
    <>
     
      {pageSize && (
        <Row className='justify-content-end align-items-center py-2'>
          <Col hidden={display} className=''style={{ display: "flex", alignItems: "center" }}>
            <span className='text-dark f-14 font-weight-600'>Display</span>
            <Input
              type='select'
              onChange={handlePageSizeChange}
              bsSize='sm'
              className='display-select d-inline-block pages_view'
              style={{ lineHeight: "20px" }}

              value={pageSize}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Input>
            <span className='text-dark f-14 d-inline-block font-weight-500'>Records</span>
         
          </Col>
          {name &&
          <Col>
          <h5 className="f-16 text-primary font-weight-600 ">
     NDC Details 
         </h5>
          </Col>
}
         
          <Col xs='auto'>
            {accuntErr && (
              <div className="text-danger font-size-12">
                Wholesaler Configuration already exists
              </div>
            )}
          </Col>
          <Col xs='auto'>
            {hasColselect && (
              <Button
                size='sm'
                color="primary"
                className='ms-auto'
                onClick={onSelectColoums}
                style={{ height: 35 }}

              >
                Column selector
              </Button>
            )}
          </Col>
          <Col xs='auto'>
          <div className="d-flex align-items-center ex_dropdown">

            {(AllExport && hasExportPermission) && (<UncontrolledDropdown group disabled={!data.length}  >
              <Button size='sm'
                color='primary'
                className='ms-auto'
                onClick={onExport}
                disabled={!data?.length}
                hidden={(hasPermission3('EX'))}
                 >
                Export
              </Button>
              <DropdownToggle
                className='ms-auto'
                caret
                color="primary"
                size='sm'
                outline
                disabled={!data.length}
              />
              <DropdownMenu className='border-0 p-1 status-dropdown' >
                <DropdownItem onClick={AllExport}>All Columns</DropdownItem>
                <DropdownItem onClick={slelectedExport} >Selected Columns</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>)}
            {addbutton? 
              <Button size='sm'
                color='primary'
                className='ms-auto upload_btn'
                // style={{marginRight:"10px",padding:"2px 8px"}}
              hidden={(!(hasPermission2('UP')) && add == "Upload") || (!hasPermission('AD') && add == "Add") || (!hasPermission2('ED') && add == "Edit") || isNonSplit}
               onClick={() => { buttononclick() }}
                  disabled={!data.length && addAccmulations == false}
                > <span className="" style={{ paddingRight: "4px", position: "relative", top: "-1px", }}>{add == "Edit" ? <img src={EditIcon} alt='' /> : <img src={plus} alt="" />}</span>
                  {add}
                </Button>
                : null}
              {saveEdit ?
                <div>
                  <Button className='reset' color='primary' onClick={e => cancelonClick(false, false)}><span className="right_5"><img src={cancel} alt='' /></span> Cancel</Button>
                  <Button className='search ms-3' color='primary' onClick={() => { saveonClick(true, false) }}><span><img src={save} alt='' /></span> Save</Button>
                </div>
                : null}         

            {(onExport && hasExportPermission) && (
              <Button
                size='sm'
                color='export'
                className='ms-auto'
                onClick={onExport}
                disabled={!data.length}
              >
                 <span className="">
                    <img style={{ width: "14px" }} src={download} alt="" />
                  </span>{" "}
                Export
              </Button>
            )}
            {!hidefilter && (
              <>
              <span className='ps-3 pe-2 f-13 font-weight-600'>Filter</span>
            <ButtonGroup className='filter-btn-group'>
              <Button
                color='info'
                outline
                onClick={() => onClickFilter('off')}
                active={rSelected === 'off'}
                disabled={!data.length}
              >
                OFF
              </Button>
              <Button
                color='info'
                outline
                onClick={() => onClickFilter('on')}
                active={rSelected === 'on'}
                disabled={!data.length}
              >
                ON
              </Button>
            </ButtonGroup>
              </>
            )}
          </div>

          </Col>
          {showtoggle==true && (
            <Col xs="auto p-0">
              <div
                className="togglesider ps-3 ms-3"
                style={{ cursor: "pointer" }}
                onClick={toggleSider}
              >
                <img
                  collapseSider
                  src={!collapseSider ? collapse : collapseclose}
                  className=""
                />
              </div>
            </Col>
          )}
           {/* <Col xs="auto p-0">
              <div
                className="togglesider ps-3 ms-3"
                style={{ cursor: "pointer" }}
                onClick={toggleSider}
              >
                <img
                  collapseSider
                  src={!collapseSider ? collapse : collapseclose}
                  className=""
                />
              </div>
            </Col> */}
        </Row>
      )}
      <div
        className='rounded-table'
        ref={selectRef}
        id={id}
        onMouseLeave={handleMouseLeave}
        onMouseMove={handleMouseEnter}
      >
        {!loader && loading && <Loader opacity={0.01} color='black' />}
        {renderScrollArrowButtons()}
        <Table
          responsive
          id='reactstrap-table'
          className={`table ${getTableClass(data,id)} theme-table ${fixedColumn ? "fixed-column-table" : ""
          }`}
          style={{ scrollBehavior: 'smooth' }}
        >
          {headerRenderer()}
          <tbody>
            {colFilterEnable && columnFilters()}
            {renderRow()}
          </tbody>
        </Table>
      </div>
      {/* {showreportscount==true?<div>
        <div className='w-100'
        style={{backgroundColor:"red"}}
        >
        </div>
      </div>:""} */}

      {hasPagination && (
        <Pagination
          onPageChange={onHandlePageChange}
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          hasNoEligibility={hasNoEligibility}
          researchNeededCount={researchNeededCount}
          eligibleCount={eligibleCount}
          inEligibleCount={inEligibleCount}
        />
      )}
    </>
  );
};

export default ReactStrapTable;
